import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense, useEffect, useState } from 'react';
import { useGroupList } from './hooks';
import { convertToPresentationProps } from './logics';
import { GroupListPresentation } from './presentations';
import { GroupRow } from './types';

/**
 * グループ一覧のコンテナコンポーネント
 */
export const GroupList: React.FC = () => {
  return (
    <Suspense fallback={<Loader />}>
      <GroupListInner />
    </Suspense>
  );
};

const GroupListInner: React.FC = () => {
  const {
    state,
    actions: {
      setSortParams,
      handleClickRow,
      onClickMenu,
      onCloseMenu,
      onClickEdit,
      onClickDelete,
    },
  } = useGroupList();

  const { groups: convertedGroups, createLink } = convertToPresentationProps({ data: state });
  const [groups, setGroups] = useState<GroupRow[]>([]);

  useEffect(() => {
    setGroups(convertedGroups);
  }, [state.groups]);

  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: '利用企業', href: '/clients' }, { label: 'グループ' }]}
      />
      <GroupListPresentation
        groups={groups}
        setGroups={setGroups}
        createLink={createLink}
        sortParams={state.sortParams}
        menuAnchorEl={state.menuAnchorEl}
        setSortParams={setSortParams}
        onClickRow={handleClickRow}
        onClickMenu={onClickMenu}
        onCloseMenu={onCloseMenu}
        onClickEdit={onClickEdit}
        onClickDelete={onClickDelete}
      />
    </>
  );
};
